import React, { FC } from 'react';
import { ContentStyled } from './styled';
export const Content: FC = (props) => {
  return <ContentStyled {...props} />;
};
